<template>
  <div class="content-wrapper">
    <vs-row class="my-4">
      <vs-col vs-lg="8" vs-sm="12">
        <!--
        <vs-button
          :to="`/conferences/speakers/add`"
          color="primary"
          type="filled"
          >Add New</vs-button
        >
        <vs-button
          @click="openFilter()"
          color="primary"
          type="filled"
          class="ml-3"
          >Filter</vs-button
        >
        -->
      </vs-col>
      <vs-col vs-lg="4" vs-sm="12">
        <div style="float: right">
          <vs-input
            id="search"
            class="inputx"
            placeholder="Search..."
            v-model="search"
            v-on:input="debounceInput"
          />
        </div>
      </vs-col>
    </vs-row>

    <vx-card>
      <b-table
        ref="table"
        style="min-height: 600px"
        striped
        hover
        fixed
        responsive
        show-empty
        sort-icon-left
        :selectable="true"
        :select-mode="`multi`"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="columns"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :filterIncludedFields="filterOn"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
      >
        <template v-slot:table-busy>
          <div class="text-center text-danger my-2" style="height: 600px">
            <b-spinner class="align-middle"></b-spinner>
            <div class="mt-3">
              <strong>Loading...</strong>
            </div>
          </div>
        </template>

        <template v-slot:cell(featured_status)="data">
          <vs-switch
            v-model="data.item.featured_status"
            icon-pack="feather"
            vs-icon="icon-star"
            @change="onStatusChanged(data.item)"
          />
        </template>

        <template v-slot:cell(publish_status)="data">
          <vs-switch
            v-model="data.item.publish_status"
            icon-pack="feather"
            vs-icon="icon-check"
            @change="onStatusChanged(data.item)"
          />
        </template>

        <template v-slot:cell(listing_status)="data">
          <vs-switch
            v-model="data.item.listing_status"
            icon-pack="feather"
            vs-icon="icon-check"
            @change="onStatusChanged(data.item)"
          />
        </template>

        <template v-slot:cell(action)="data">
          <div style="width: 300px">
            <vs-button @click="open(data.item)" color="primary" type="flat"
              >View</vs-button
            >

            <a
              :download="`auction_${data.item.slug}.png`"
              target="_blank"
              :href="
                `https://chart.googleapis.com/chart?chs=400x400&cht=qr&chl=https://go.soldoutt.com/${e}/auction/${data.item.slug}`
              "
              color="primary"
              type="flat"
              >QR Code</a
            >
          </div>
        </template>
      </b-table>
    </vx-card>

    <filter-modal :list="filterList" @close="onFilterModalClose"></filter-modal>
  </div>
</template>
<script>
import Service from "@/services";

import { mapState } from "vuex";
import FilterModal from "@/components/soldoutt/FilterModal.vue";

export default {
  components: {
    FilterModal
  },
  data: () => ({
    columns: [
      { label: "ID", key: "product_id", sortable: false },
      {
        label: "Publish Status",
        key: "publish_status",
        sortable: false
      },
      {
        label: "Listing Status",
        key: "listing_status",
        sortable: false
      },
      {
        label: "Name",
        key: "pro_name",
        sortable: false,
        tdClass: "width-450"
      },
      { label: "", key: "action", tdClass: "width-300", sortable: false }
    ],
    search: "",
    filter: "",
    sortBy: "",
    sortDesc: false,
    sortDirection: "asc",
    from: 1,
    to: 0,
    isBusy: false,
    currentPage: 1,
    perPage: 100,
    totalRows: 0,
    selected: [],
    filterOn: [],
    pageOptions: [2, 5, 10, 15, 30, 50],
    filterList: []
  }),
  computed: {
    ...mapState({
      s: state => {
        return state.Utility.s;
      },
      e: state => {
        return state.Utility.e;
      }
    })
  },
  methods: {
    debounceInput: _.debounce(function(e) {
      this.filter = e;
      this.search = e;
    }, 500),
    checkSearchStr: _.debounce(function(val) {
      this.filter = val;
      this.$refs.table.refresh();
    }, 500),
    onStatusChanged: _.debounce(function(e) {
      let data = {
        e: this.e,
        product_id: e.product_id,
        publish_status: e.publish_status,
        featured_status: e.featured_status,
        listing_status: e.listing_status
      };

      this.$vs.loading();
      Service.LiveProduct.update(data).then(res => {
        if (res.success) {
          this.$vs.notify({
            title: "Success",
            text: "Update complete.",
            color: "success"
          });
        }

        this.$vs.loading.close();
      });
    }, 500),
    dataProvider(ctx, callback) {
      setTimeout(() => {
        this.isBusy = true;
        let data = {
          e: this.$route.query.e
        };

        let params = Object.keys(data)
          .map(key => key + "=" + data[key])
          .join("&");

        params =
          params +
          "&" +
          Object.keys(ctx)
            .map(key => key + "=" + ctx[key])
            .join("&");

        Service.LiveProduct.gets(params)
          .then(res => {
            this.isBusy = false;
            this.totalRows = res.data.total;
            this.from = res.data.from;
            this.to = res.data.to;
            this.data = res.data.rows.map(item => {
              return {
                ...item
              };
            });
            callback(this.data);
          })
          .catch(error => {
            console.log(error);
            // Here we could override the busy state, setting isBusy to false
            // this.isBusy = false
            // Returning an empty array, allows table to correctly handle
            // internal busy state in case of error
            //return [];
            callback([]);
          });
        return null;
      }, 1000);
    },
    open(item) {
      this.$router.push(
        "/conferences/auctions/" +
          item.product_id +
          "/view?s=" +
          this.s +
          "&e=" +
          this.e
      );
    },
    openFilter() {
      this.$bvModal.show("filter-modal");
    },
    onFilterModalClose() {
      this.$bvModal.hide("filter-modal");
    }
    /*
    duplicate(item) {
      this.$router.push("/conferences/speakers/add?clone=" + item.e);
    },
    */
  }
};
</script>
